import React from 'react';
import Chip from '@mui/material/Chip';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { getAggStatusColor } from 'routes/BudgetModule/helpers/statusHelpers';

export default function AggStatusCellRenderer({
    value,
    valueFormatted,
}: CellRendererParams<unknown, string>): React.ReactElement {
    if (!value) return <></>;

    const color = getAggStatusColor(value);

    return (
        <Chip
            style={{
                color,
                borderColor: color,
                // @ts-expect-error [TS migration] style is not a valid CSS property. Probably meant borderStyle
                style: 'solid 1px',
                fontSize: '12px',
                borderRadius: '4px',
            }}
            size="small"
            variant="outlined"
            label={valueFormatted}
        />
    );
}
